// extracted by mini-css-extract-plugin
export default {"input":"InputComponent_input__JeTed","removeIco":"InputComponent_removeIco__0k7Ah"};